import { render } from "./ProductTileView.vue?vue&type=template&id=1c6ac5f8&scoped=true&ts=true"
import script from "./ProductTileView.vue?vue&type=script&lang=ts"
export * from "./ProductTileView.vue?vue&type=script&lang=ts"

import "./ProductTileView.vue?vue&type=style&index=0&id=1c6ac5f8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6ac5f8"]])

export default __exports__